import Vue from 'vue';
import { addClass, removeClass } from './dom';

let hasModal = false;

const getModal = () => {
    // 为什么这里是server的话，下面的代码不执行呢?
    if (Vue.prototype.$isServer) {
        return;
    }
    let modalDom = PopupManager.modalDom;
    if (modalDom) {
        hasModal = true;
    } else {
        hasModal = false;
        modalDom = document.createElement('div');
        PopupManager.modalDom = modalDom;

        modalDom.addEventListener('touchmove', (event) => {
            event.preventDefault();
            event.stopPropagation();
        });

        modalDom.addEventListener('click', () => {
            if (PopupManager.doOnModalClick) {
                PopupManager.doOnModalClick();
            }
        });
    }

    return modalDom;
};

// 一个map
const instances: {
    [id: string]: any,
} = {};

// 类似于toast来控制的?
const PopupManager: {
    zIndex: number;
    modalFade: boolean;
    modalDom?: HTMLElement,
    modalStack: Array<{
        id: string,
        zIndex: number,
        modalClass: string,
    }>;
    getInstance(id: string): any;
    register(id: string, instance: any): void;
    deregister(id: string): void;
    nextZIndex(): number;
    doOnModalClick(): void;
    openModal(id: string, zIndex: number, dom: any, modalClass: string, modalFade: any): void;
    closeModal(id: string): void;
} = {
    zIndex: 2000,
    modalFade: true,

    getInstance(id: string) {
        return instances[id];
    },

    register(id: string, instance) {
        if (id && instance) {
            instances[id] = instance;
        }
    },

    deregister(id: string) {
        if (id) {
            instances[id] = null;
            delete instances[id];
        }
    },

    nextZIndex() {
        return PopupManager.zIndex++;
    },
    // todo 如何做类型标记呢
    modalStack: [],

    doOnModalClick() {
        const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
        if (!topItem) {
            return;
        }

        const instance = PopupManager.getInstance(topItem.id);
        if (instance && instance.closeOnClickModal) {
            instance.close();
        }
    },

    openModal(id: string, zIndex: number, dom, modalClass: string, modalFade) {
        if (Vue.prototype.$isServer) {
            return;
        }
        if (!id || zIndex === undefined) {
            return;
        }
        this.modalFade = modalFade;

        const modalStack = this.modalStack;

        for (let i = 0, j = modalStack.length; i < j; i++) {
            const item = modalStack[i];
            if (item.id === id) {
                return;
            }
        }

        const modalDom = getModal();

        addClass(modalDom!, 'v-modal');
        if (this.modalFade && !hasModal) {
            addClass(modalDom!, 'v-modal-enter');
        }
        if (modalClass) {
            const classArr = modalClass.trim().split(/\s+/);
            classArr.forEach((item) => addClass(modalDom!, item));
        }
        setTimeout(() => {
            removeClass(modalDom!, 'v-modal-enter');
        }, 200);

        if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
            dom.parentNode.appendChild(modalDom);
        } else {
            // @ts-ignore
            document.body.appendChild(modalDom);
        }

        if (zIndex) {
            // @ts-ignore
            modalDom.style.zIndex = zIndex;
        }
        // @ts-ignore
        modalDom.style.display = '';

        this.modalStack.push({ id, zIndex, modalClass });
    },

    closeModal(id: string) {
        const modalStack = this.modalStack;
        const modalDom = getModal();

        if (modalStack.length > 0) {
            const topItem = modalStack[modalStack.length - 1];
            if (topItem.id === id) {
                if (topItem.modalClass) {
                    const classArr = topItem.modalClass.trim().split(/\s+/);
                    classArr.forEach((item) => removeClass(modalDom!, item));
                }

                modalStack.pop();
                if (modalStack.length > 0) {
                    // @ts-ignore
                    modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
                }
            } else {
                for (let i = modalStack.length - 1; i >= 0; i--) {
                    if (modalStack[i].id === id) {
                        modalStack.splice(i, 1);
                        break;
                    }
                }
            }
        }

        if (modalStack.length === 0) {
            if (this.modalFade) {
                addClass(modalDom!, 'v-modal-leave');
            }
            setTimeout(() => {
                if (modalStack.length === 0) {
                    // @ts-ignore
                    if (modalDom.parentNode) {
                        // @ts-ignore
                        modalDom.parentNode.removeChild(modalDom);
                    }
                    // @ts-ignore
                    modalDom.style.display = 'none';
                    PopupManager.modalDom = undefined;
                }
                removeClass(modalDom!, 'v-modal-leave');
            }, 200);
        }
    },
};

if (!Vue.prototype.$isServer) {
    window.addEventListener('keydown', (event) => {
        if (event.keyCode === 27) { // ESC
            if (PopupManager.modalStack.length > 0) {
                // modalStack顶部内容
                const topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
                if (!topItem) {
                    return;
                }
                // 处理instance
                const instance = PopupManager.getInstance(topItem.id);
                // 这里是否有问题
                if (instance.closeOnPressEscape) {
                    instance.close();
                }
            }
        }
    });
}

export default PopupManager;
